<div
  fxLayout="column"
  class="height-100">

  <!-- Toolbar -->
  <div>
    <mat-toolbar fxLayout="row">
      <!-- Close -->
      <span>
        <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="close()" type="button">
          <mat-icon *ngIf="!media.isActive('lt-sm')" svgIcon="close"></mat-icon>
          <mat-icon *ngIf="media.isActive('lt-sm')" svgIcon="arrow-left"></mat-icon>
        </button>
      </span>

      <!-- Detail Title -->
      <span 
        fxLayout="row" 
        fxLayoutAlign="center center"
        [class.compact-header-text]="media.isActive('lt-sm')"
        fxFlex="noshrink">        
        {{ 'LABEL_DETAIL' | translate: {type: type} }}
      </span>    

      <button 
        mat-icon-button 
        [matMenuTriggerFor]="menu"
        *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update) || moduleCode == 'RM'"
        >
        <mat-icon svgIcon="dots-vertical"></mat-icon>
      </button>

      <mat-menu #menu="matMenu">

        <!-- Edit -->
        <button 
          mat-menu-item 
          (click)="modify()" 
          *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update)"
          >
          <mat-icon svgIcon="pencil"></mat-icon>
          <span> {{ 'LABEL_EDIT' | translate }} </span>
        </button>
        
      </mat-menu>
    </mat-toolbar>
  </div>

  <!-- Detail Data -->
  <div class="width-100 overflow-auto" fxFlex>
    <mat-list>
      <mat-list-item 
        class="detail-list-height margin-top-5"
        *ngFor="let key of detailKeys">
        <h3 matLine class="list-data">
          <span 
            class="word-wrap"
            [class.preline]="key === 'web_user_company'">
            <!-- {{ detailData[key] }} -->
            {{ (key == 'is_active' || key == 'terminal_is_registered' || key == 'web_user_role_is_active') ? (helper.displayFields(detailData, key) | translate) : helper.displayFields(detailData, key, moduleCode, displayMode, descriptionOnly) }}
          </span>
        </h3>
        <p matLine class="list-label">
          {{ helper.displayDetailLabel(key, moduleCode, displayMode) | translate }}
        </p>
      </mat-list-item>
    </mat-list>
  </div>

</div>